<template>
	<div class="card text-center header-silo">
		<div @click="navigateToAnteSilo" style="cursor: pointer;">
			<i class="fa-solid fa-circle-chevron-left icon-header"></i>
		</div>
		<div>
			<h4 class="title-relatorio" style="color: #000; font-weight: bold">
				{{ silo.nome }}
			</h4>
			<small>{{ vue_app_name }} v{{ version }} </small>
		</div>
		<div @click="navigateToProxSilo" style="cursor: pointer;">
			<i class="fa-solid fa-circle-chevron-right icon-header"></i>
		</div>
	</div>
</template>

<script>
	import { useRouter } from 'vue-router';
	import { useStore } from 'vuex';
	import { ref, watch, computed } from 'vue';

	export default {
		props: {
			silo: {
				type: Object,
				required: true
			},
			unidadeId: {
				type: String,
				required: true
			}
		},

		setup(props) {
			const router = useRouter();
			const store = useStore();
			const vue_app_name = process.env.VUE_APP_NAME;
			const version = process.env.VUE_APP_VERSION;
			const silos = ref([]);

			watch(() => store.state.silos.silos,(newSilos) => {
					silos.value = newSilos;
				}, { immediate: true }
			);

			const silosOrdenados = computed(() => {
				return silos.value.slice().sort((a, b) => {
					const numA = parseInt(a.nome.match(/\d+/)[0]);
					const numB = parseInt(b.nome.match(/\d+/)[0]);
					return numA - numB;
				});
			});

			const navigateToAnteSilo = () => {
				const idSiloAtual = silosOrdenados.value.findIndex(silo => silo.id === props.silo.id);
				if (idSiloAtual > 0) {
					const idAnteSilo = silosOrdenados.value[idSiloAtual - 1].id;
					router.push(`/v1/unidades/${props.unidadeId}/silos/${idAnteSilo}`);
				} else {
					const idUltimoSilo = silosOrdenados.value[silosOrdenados.value.length - 1].id;
					router.push(`/v1/unidades/${props.unidadeId}/silos/${idUltimoSilo}`);
				}
			};

			const navigateToProxSilo = () => {
				const idSiloAtual = silosOrdenados.value.findIndex(silo => silo.id === props.silo.id);
				if (idSiloAtual < silosOrdenados.value.length - 1) {
					const idProxSilo = silosOrdenados.value[idSiloAtual + 1].id;
					router.push(`/v1/unidades/${props.unidadeId}/silos/${idProxSilo}`);
				} else {
					const idPrimeiroSilo = silosOrdenados.value[0].id;
					router.push(`/v1/unidades/${props.unidadeId}/silos/${idPrimeiroSilo}`);
				}
			};

			return {
				vue_app_name,
				version,
				navigateToAnteSilo,
				navigateToProxSilo
			};
		}
	};
</script>

<style scoped>
	.header-silo {
		height: 10vh;
		padding: 1em;
		border-radius: 0px !important;
		display: flex;
		align-content: stretch;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
        box-shadow: 0px 8px 20px 0px #d5c0c0;
        background-color: #ffffff !important;
	}

	.icon-header {
		font-size: 1.8rem; /* Ajuste o tamanho conforme necessário */
	}
</style>
